import React from "react";
import { router } from "@inertiajs/react";

const MENTION_REGEX = /@([a-z0-9_]{3,30})/gi;
const HASHTAG_REGEX = /#([a-zA-Z0-9_]{1,50})\b/g;

// Hoisted out of the render: a post body is rendered line by line, so an inline
// object literal here allocated a fresh style object per line on every render.
const CHECKBOX_ROW_STYLE = {
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
};

function parseInlineElements(text, key) {
  const parts = [];
  let lastIndex = 0;
  const combined = new RegExp(
    `${MENTION_REGEX.source}|${HASHTAG_REGEX.source}`,
    "gi",
  );
  let match;

  while ((match = combined.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    if (match[0].startsWith("@")) {
      const username = match[1] || match[0].slice(1);
      const mentionHref = `/communities/profiles/${username.toLowerCase()}`;
      parts.push(
        <a
          key={`${key}-m-${match.index}`}
          href={mentionHref}
          style={{
            color: "var(--primary, #ff9900)",
            fontWeight: 600,
            textDecoration: "none",
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            router.visit(mentionHref);
          }}
        >
          @{username}
        </a>,
      );
    } else if (match[0].startsWith("#")) {
      const tag = match[2] || match[0].slice(1);
      const hashHref = `/communities/explore?topic=${tag.toLowerCase()}`;
      parts.push(
        <a
          key={`${key}-h-${match.index}`}
          href={hashHref}
          style={{
            color: "var(--primary, #ff9900)",
            fontWeight: 600,
            textDecoration: "none",
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            router.visit(hashHref);
          }}
        >
          #{tag}
        </a>,
      );
    }
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
}

export function renderContent(content) {
  if (!content) return null;
  const lines = content.split("\n");
  return lines.map((line, i) => {
    if (/^- \[[ x]\] /.test(line)) {
      const textPart = line.replace(/^- \[[ x]\] /, "");
      return (
        // Keyed by line number: this list is a pure projection of `content`, fully
        // re-derived whenever it changes, holds no per-row state, and is never
        // reordered -- so position is the stable identity. Keying by the line's
        // text would collide, since repeated lines are normal in a post body.
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <div key={i} style={CHECKBOX_ROW_STYLE}>
          <input
            type="checkbox"
            defaultChecked={line.startsWith("- [x]")}
            readOnly
            style={{ cursor: "default" }}
          />
          <span>{parseInlineElements(textPart, i)}</span>
        </div>
      );
    }
    return (
      // Line number as key -- see the note above.
      // eslint-disable-next-line @eslint-react/no-array-index-key
      <React.Fragment key={i}>
        {parseInlineElements(line, i)}
        {i < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
}
